export default "__VITE_ASSET__CW9s2dwQ__"